import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

import type { Deal, WorkItem } from "../types";
import { DealNextStepDialog } from "./DealNextStepDialog";
import { isDealOpen } from "./dealStatus";
import {
  activeNextStepDialogs,
  TASK_COMPLETED_EVENT,
  type TaskCompletedDetail,
} from "./taskCompletionEvents";

// Etter en fullført oppgave på en åpen mulighet (kap. 7.1 og 16.9): når
// muligheten ikke har flere åpne steg med dato, åpnes «Hva er neste steg?»
// etter 300 ms. Har den fortsatt et planlagt steg, er kravet oppfylt, og vi
// lar brukeren jobbe videre.
const PROMPT_DELAY_MS = 300;

export const NextStepPrompt = () => {
  const dataProvider = useDataProvider();
  const [deal, setDeal] = useState<Deal | null>(null);

  useEffect(() => {
    const onCompleted = async (event: Event) => {
      const { dealId } = (event as CustomEvent<TaskCompletedDetail>).detail;
      if (activeNextStepDialogs.has(String(dealId))) return;
      try {
        const [{ data: found }, { data: open }] = await Promise.all([
          dataProvider.getOne<Deal>("deals", { id: dealId }),
          dataProvider.getList<WorkItem>("work_items", {
            filter: { deal_id: dealId, "completed_at@is": null },
            sort: { field: "due_date", order: "ASC" },
            pagination: { page: 1, perPage: 5 },
          }),
        ]);
        if (!isDealOpen(found) || found.archived_at) return;
        if (open.some((task) => !!task.due_date)) return;
        window.setTimeout(() => setDeal(found), PROMPT_DELAY_MS);
      } catch {
        // Muligheten kan være slettet eller utilgjengelig. Ingen dialog da.
      }
    };
    window.addEventListener(TASK_COMPLETED_EVENT, onCompleted);
    return () => window.removeEventListener(TASK_COMPLETED_EVENT, onCompleted);
  }, [dataProvider]);

  return (
    <DealNextStepDialog
      deal={deal}
      afterComplete
      onClose={() => setDeal(null)}
    />
  );
};
